import { z } from 'zod';

export const MonitoringRecipientsManageModalSchema = z.object({
  recipients: z.array(z.string()).min(1, "受信者を1つ以上選択してください"),
});

export type MonitoringRecipientsManageModalData = z.infer<typeof MonitoringRecipientsManageModalSchema>;
